export const DESKTOP_AUTH_LAUNCHED_KEY = "ow-desktop-auth-launched";

export function buildDesktopAuthLink(search) {
  const params = new URLSearchParams(search);
  const code = params.get("code");
  const state = params.get("state");
  const error = params.get("error");
  if (code && state) {
    return {
      key: `state:${state}`,
      href: `overwatch://auth?code=${encodeURIComponent(code)}&state=${encodeURIComponent(state)}`,
    };
  }
  if (error) {
    const description = params.get("error_description") || "";
    return {
      key: `error:${error}`,
      href: `overwatch://auth?error=${encodeURIComponent(error)}&error_description=${encodeURIComponent(description)}`,
    };
  }
  return null;
}

export function readLaunchedDesktopAuth() {
  try {
    return window.sessionStorage.getItem(DESKTOP_AUTH_LAUNCHED_KEY);
  } catch (e) {
    return null;
  }
}

export function markDesktopAuthLaunched(key) {
  try {
    window.sessionStorage.setItem(DESKTOP_AUTH_LAUNCHED_KEY, key);
  } catch (e) {
    return;
  }
}
